<template>
  <div 
    class="switch-container"
    :class="{
      'is-checked': isChecked,
      'is-disabled': disabled
    }"
    @click="handleClick"
  >
    <div class="switch-track">
      <div class="switch-thumb"></div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  modelValue: {
    type: [Boolean, String, Number],
    default: false
  },
  activeValue: {
    type: [Boolean, String, Number],
    default: true
  },
  inactiveValue: {
    type: [Boolean, String, Number],
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:modelValue', 'change'])

const isChecked = computed(() => Object.is(props.modelValue, props.activeValue))

const handleClick = () => {
  if (props.disabled) return
  const newValue = isChecked.value ? props.inactiveValue : props.activeValue
  emit('update:modelValue', newValue)
  emit('change', newValue)
}
</script>

<style scoped>
.switch-container {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
}

.switch-container.is-disabled {
  cursor: not-allowed;
}

.switch-track {
  position: relative;
  width: 44px;
  height: 24px;
  border-radius: 12px;
  background-color: #D5DBE2;
  transition: background-color 0.3s ease;
}

.switch-container.is-checked .switch-track {
  background-color: #0068B0;
}

.switch-thumb {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #FFFFFF;
  transition: transform 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.switch-container.is-checked .switch-thumb {
  transform: translateX(20px);
}

.switch-container.is-disabled .switch-track {
  opacity: 0.4;
}

.switch-container.is-disabled .switch-thumb {
  opacity: 0.4;
}
</style>
